import SelectDivisoes from "./SelectDivisoes";
import SelectRegionais from "./SelectRegionais";
import SelectLojas from "./SelectLojas";
import React from "react";
import Button from "../Button";
import "./_styles.scss";

interface ISelectsRegionaisELojas {
  toFilter?: () => any;
  onChange?: (ev: React.FormEvent<HTMLInputElement>) => void;
  idRegional?: string;
  idLoja?: string;
  lojas?: any;
  justify?: "flex-start" | "flex-end" | null;
}

const DadosLojas = ({
  toFilter,
  onChange,
  idRegional,
  idLoja,
  lojas,
}: ISelectsRegionaisELojas) => {
  return (
    <div className="wrapper">
      <SelectDivisoes />
      <SelectRegionais idRegional={idRegional} onChange={onChange} />
      <SelectLojas idLoja={idLoja} lojas={lojas} onChange={onChange} />
      {toFilter && (
        <nav>
          <Button variant="primary" size="md" onClick={toFilter}>
            usar filtro
          </Button>
        </nav>
      )}
    </div>
  );
};

export default DadosLojas;
